module.exports = __webpack_public_path__ + "static/narzedzia-do-pracy-zdalnej-dla-firm-be98ff3aa542005dbc0bcff6d36d552f.jpg";